<template>
    <div>
        <div class="sousuo">
            <van-search
                    v-model="money"
                    placeholder="要搜索的手机号 / 姓名"
                    shape="round"
                    style="width: 60%;"
            >
            </van-search>
            <span class="soubtn" @click="onSearch">搜索</span>
            <span class="soubtn1" @click="toAddMember">创建客户</span>
        </div>
        <div class="fw-mbs">
            <el-card class="box-card" v-for="item in members">
                <div slot="header" class="clearfix">
                    <div class="fw-mb">
                        <div style="display: flex;width: 80%">
                            <div class="mb-name">
                                <img src="./../../assets/hyname.png" class="kdimg" />
                                <span >{{item.memberName}}</span>
                            </div>
                            <div>
                                <span v-if="item.sex == 0">未知</span>
                                <span v-if="item.sex == 1">男</span>
                                <span v-if="item.sex == 2">女</span>
                                <span style="line-height: 29px;font-size: 9px;margin-left: 3px" v-if="item.phone">({{ item.phone }})</span>
                            </div>
                        </div>
                        <div class="djnr">
                            <img src="./../../assets/banka.png" class="bkimg" />
                            <el-button class="memberbtn1" type="text" @click="toBk(item)">办卡</el-button>
                        </div>
                    </div>
                </div>
                <div class="card-item" v-if="item.memberCards.length>0" v-for="card in item.memberCards">
                    <div class="kaneirong">
                        <span class="cardname"> {{card.cardName}} ( {{card.itemDiscount}}折 )</span>
                        <div class="djnr">
                            <img src="./../../assets/vip.png" class="kdimg" />
                            <el-button class="memberbtn1" type="text" @click="toKd('A',item,card)">开单</el-button>
                        </div>
                        <div class="djnr" style="margin-left: 15px">
                            <img  src="./../../assets/haoma.png" class="kdimg" />
                            <el-button class="memberbtn1" type="text" @click="toFwh('A',item,card)">选择服务号</el-button>
                        </div>
                    </div>
                    <div class="kaye">
                            <span style="line-height: 30px">卡金 : ¥{{card.balance}}</span>
                            <span style="line-height: 30px">赠送金 : ¥{{card.giveBalance}}</span>
                    </div>
                </div>
                <div v-if="!item.memberCards||item.memberCards.length<=0" class="wuka">
                    <div class="djnr" style="margin-right: 35px">
                        <img src="./../../assets/vip.png" class="kdimg" />
                        <el-button class="memberbtn1" type="text" @click="toKd('B',item)">开单</el-button>
                    </div>
                    <div class="djnr">
                        <img  src="./../../assets/haoma.png" class="kdimg" />
                        <el-button class="memberbtn1" type="text" @click="toFwh('B',item)">选择服务号</el-button>
                    </div>
                </div>
            </el-card>
        </div>
        <van-popup v-model="addShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <AddMemmber ref="addmb" @gbMember="gbMember" :addType="addType"/>
        </van-popup>

        <van-popup v-model="bkShow" position="bottom" lock-scroll closeable overlay :close-on-click-overlay="false" style="height: 100%;overflow:hidden;">
            <Bk v-if="bkShow" ref="bk" @gbBk="gbBk"  :memberId="memberId"/>
        </van-popup>
    </div>
</template>

<script>

    import {getCookie} from "../../utils/auth";
    import AddMemmber from "../common/addMember";
    import Bk from "../customer/center/card";
    export default {
        components: {AddMemmber,Bk},
        data() {
            return {
                deptId:'',
                token:'',
                money:'',
                members:[],

                addType:'',
                addShow:false,

                memberId:'',
                bkShow:false,
            };
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            toBk(item){
                this.memberId=item.id
                this.bkShow=true
            },
            gbBk(){
                this.bkShow=false
                this.onSearch()
            },
            toAddMember() {
                this.addShow = true
                if (this.$refs.addmb) {
                    this.$refs.addmb.chushi();
                }
            },
            gbMember(member) {
                if (member){
                    this.money = member.phone.slice(-4);
                    if (this.money){
                        this.onSearch()
                    }
                }
                this.addShow = false
            },

            async onSearch() {
                if (!this.money) {
                    this.$notify("请输入要搜索的手机号 / 姓名!");
                    return;
                }
                let data = {
                    deptId: this.deptId,
                    name: this.money,
                };
                let res = await this.$get("/fw/getFwMembers", data);
                if (res.code == 200) {
                    this.members = res.list;
                }
            },

            async toKd(type,mb,card){
                let str=''
                let res = await this.$get("/sw/getServiceNo", {token: this.token});
                //会员卡
                if (type=='A'){
                    str='?memberId='+mb.id+'&cardId='+card.id+'&fwh='+res.serviceNo
                }
                //会员
                if (type=='B'){
                    str='?memberId='+mb.id+'&fwh='+res.serviceNo
                }
                if (this.fwUser.userType==2){
                    this.$router.push('/mdBilling'+str)
                }
                if (this.fwUser.userType==3){
                    this.$router.push('/empBilling'+str)
                }
            },
            toFwh(type,mb,card){
                let str=''
                //会员卡
                if (type=='A'){
                    str='?memberId='+mb.id+'&cardId='+card.id
                }
                //会员
                if (type=='B'){
                    str='?memberId='+mb.id
                }
                if (this.fwUser.userType==2){
                    this.$router.push('/mdChoose'+str)
                }
                if (this.fwUser.userType==3){
                    this.$router.push('/empChoose'+str)
                }
            },
            // setMember(mb,card){
            //     let data={
            //         mb:mb,
            //         card:card,
            //     }
            //     this.$emit('setMember',data)
            // },
        },
    };
</script>

<style lang="scss" scoped>
 .sousuo{
     padding: 15px 8px;
     margin-top: 12px;
     display: flex;
     flex-direction: row;
     justify-content: center;
     align-items: center
 }
    .fw-mbs{
        display: flex;
        flex-direction: column;
        border-top: #dddddd solid 1px;
        padding: 10px;
    }
    .fw-mb{
        display: flex;
        flex-direction: row;
        height: 25px;
        text-align: center;
        font-size: 12px;
        justify-content: space-between;
    }
    .mb-name{
        width: 30%;
        line-height: 25px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 10px;
        text-align: left;
        display: flex;
        align-items: center;
    }

     /deep/ .el-card__body {
         padding: 10px;
     }
     /deep/ .el-card__header {
         padding: 10px;
         border-bottom: 0.02667rem solid #EBEEF5;
         box-sizing: border-box;
         font-size: 13px;
     }

 .soubtn {
     width: 45px;
     font-size: 13px;
     background-color: #FBBA5F;
     height: 28px;
     line-height: 28px;
     border-radius: 25px;
     text-align: center;
 }
 .soubtn1 {
     width: 55px;
     font-size: 13px;
     height: 28px;
     line-height: 28px;
     text-align: center;
     margin-left: 10px;
     color: #2b94ff;
 }

 .memberbtn1 {
     width: 10%;
     font-size: 13px;
     text-align: right;
 }
 .card-item {
     display: flex;
     flex-direction: column;
     /*justify-content: space-between;*/
     font-size: 10px;
     padding-bottom: 8px;
 }
 .djnr{
     display: flex;
     flex-direction: row;
     align-items: center;
 }
  .kdimg{
     width: 12px;
     height: 12px;
     margin-right: 3px;
  }
  .bkimg{
     width: 13px;
     height: 13px;
     margin-right: 3px;
  }
    .wuka{
        display: flex;
        flex-direction: row;
        justify-content: center
    }
    .kaneirong{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .cardname{
        width: 50%;
        line-height: 20px
    }
    .kaye{
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 10px;
    }

</style>